import { render, staticRenderFns } from "./TodoTaskHandlerSidebar.vue?vue&type=template&id=729c6784&scoped=true&"
import script from "./TodoTaskHandlerSidebar.vue?vue&type=script&lang=js&"
export * from "./TodoTaskHandlerSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TodoTaskHandlerSidebar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TodoTaskHandlerSidebar.vue?vue&type=style&index=1&id=729c6784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729c6784",
  null
  
)

export default component.exports